<template>
    <div id="hospDetail" class="sys-page">
        <div class="breadcrumb">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item to="/hospManage">医院管理</el-breadcrumb-item>
                <el-breadcrumb-item>医院信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card class="box-card">
            <p class="title">
                医院信息
                <img src="../assets/edit.png" class="editMsg" title="编辑" @click="editHospMsg()" alt="">
            </p>
            <div>
                <div class="list">
                    <span class="keyWord">医院编号 : </span><span class="content">{{hospMsg.hospCode}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院名称 : </span><span class="content">{{hospMsg.hospName}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院负责人 : </span><span class="content">{{hospMsg.hospAdminName}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院电话 : </span><span class="content">{{hospMsg.hospAdminTel}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院等级 : </span><span class="content">{{hospMsg.hospRank}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院地址 : </span><span class="content">{{hospMsg.hospAddr}}</span>
                </div>
                <div class="list">
                    <span class="keyWord">医院简介 : </span><span class="content">{{hospMsg.hospDesc}}</span>
                </div>
            </div> 
            <p class="title">管理员信息</p>
            <div style="text-align:left"> 
                <el-button type="primary" size="small" style="margin-left:20px;" v-show="!flag" @click="addAdminDialog=true">创建管理员</el-button>
                <p class="list" v-show="flag">管理员姓名 ：{{adminMsg.userName}}</p>
                <p class="list" v-show="flag">管理员账号 ：{{adminMsg.userTel}} <span class="editPwd" @click="resetPassword()">重置密码</span></p>
                <el-button type="primary" size="small" style="margin-left:20px;margin-top:10px;" @click="docManage()">医生管理</el-button>
            </div>
            <p class="title">
                收费信息
                <img src="../assets/edit.png" class="editMsg" title="编辑" @click="editCharge()" alt="">
            </p>
            <div>
                <p class="list" v-if="balanceMsg.chargeStatus=='02'">标准价格 ：<span style="color:red;text-decoration:line-through">{{balanceMsg.standardPrice}} 元 / 次</span></p>
                <p class="list" v-if="balanceMsg.chargeStatus=='01'">标准价格 ：<span style="color:red">{{balanceMsg.standardPrice}} 元 / 次</span></p>
                <p class="list">是否收费 ：<span style="color:red">{{transfCharge(balanceMsg.chargeStatus)}}</span></p>
            </div>
        </el-card>
        <el-card class="box-card">
            <p class="title">下级医院</p>
            <div style="margin:10px 0" align="left">
                <el-row :gutter="10">
                    <el-col align="left" :span="16">
                        <el-button type="primary"  @click="addDialog = true" size="small">添加下级医院</el-button>
                    </el-col>
                    <el-col align="center" :span="7">
                        <el-input v-model="hospName" size="small" placeholder="医院名称" clearable @keyup.enter.native="getHospList(1)"></el-input>
                    </el-col>
                        <el-col align="center" :span="1">
                        <el-button icon="el-icon-search" size="small" circle @click="getHospList(1)"></el-button>
                    </el-col>
                </el-row>
            </div>
            <div>
                <template class="tableList">
                    <el-table :data="hospList.body" ref="hospList"  style="width: 100%">
                        <el-table-column type="index" align="center" label="序号" > </el-table-column>
                        <el-table-column prop="hospCode" align="center" label="医院编号" > </el-table-column>
                        <el-table-column prop="hospName" align="center" label="医院名称" > </el-table-column>
                        <el-table-column prop="hospRank" align="center" label="等级"></el-table-column>
                        <el-table-column prop="priceDif" align="center" label="差价"></el-table-column>
                        <el-table-column prop="" align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="charge(scope.row)">收费设置</el-button>
                                <el-button type="text" size="small" style="color:red" @click="deleteHosp(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </div>
            <div class="page">
                <el-pagination  :page-size="15" :page-count="5" layout="total, prev, pager, next" :total="hospList.count" @current-change='changePage' style="text-align:right"></el-pagination>
            </div>
        </el-card>
        <el-dialog title="修改医院信息" :visible.sync="editHosp" width="700px" center>
            <el-form ref="editMsg" :model="editMsg" :rules="editMsgRules" label-width="120px">
                <el-form-item label="医院名称">
                    <el-input type="text" placeholder="请输入医院名称" v-model="editMsg.hospName"></el-input>
                </el-form-item>
                <el-form-item label="医院级别">
                    <el-select v-model="editMsg.hospRank" placeholder="等级" style="width:100%;">
                        <el-option v-for="item in hospRanks" :label="item.dictDesc" :value="item.dictDesc" :key="item.dictDesc"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="医院负责人" prop="hospAdminName">
                    <el-input type="text" placeholder="请输入医院负责人" v-model="editMsg.hospAdminName"></el-input>
                </el-form-item>
                <el-form-item label="医院电话" prop="hospAdminTel">
                    <el-input type="text" placeholder="请输入医院电话" v-model="editMsg.hospAdminTel"></el-input>
                </el-form-item>
                <el-form-item label="医院详细地址" prop="hospAddr">
                    <el-input type="text" placeholder="请输入医院详细地址" v-model="editMsg.hospAddr"></el-input>
                </el-form-item>
                <el-form-item label="医院介绍">
                    <el-input type="textarea" autosize placeholder="请输入医院介绍" v-model="editMsg.hospDesc"></el-input>
                </el-form-item>
                <div style="display:flex;justify-content:flex-end;margin-top:40px;">
                    <el-button size='small' @click="cancel()">取消</el-button>
                    <el-button type="primary" size='small' @click="update()">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="修改收费信息" :visible.sync="editChar" width="700px" center>
            <el-form ref="editMsg" :model="editCharMsg" :rules="editCharMsgRules" label-width="120px">
                <el-form-item label="是否收费" prop="chargeStatus">
                    <el-radio-group v-model="editCharMsg.chargeStatus" class="radioGroup">
                        <el-radio v-model="editCharMsg.chargeStatus" label="01">是</el-radio>
                        <el-radio v-model="editCharMsg.chargeStatus" label="02">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="标准价格" prop="standardPrice">
                    <el-input style="width:60%;margin-right:10px" :disabled="editCharMsg.chargeStatus=='02'" type="text" placeholder="请输入医院对外收费的标准价格,单位：元" v-model="editCharMsg.standardPrice"></el-input> 元 / 次
                </el-form-item>
                <div style="display:flex;justify-content:flex-end;margin-top:40px;">
                    <el-button size='small' @click="cancel()">取消</el-button>
                    <el-button type="primary" size='small' @click="saveHospAccount()">保存</el-button>
                </div>
            </el-form>
        </el-dialog>
        <el-dialog title="下级医院收费设置" :visible.sync="chargeRule" width="600px" center>
            <el-form ref="editMsg" :model="childCharg" :rules="childChargRules" label-width="120px">
                <el-form-item label="医院编号">
                    <span>{{childCharg.hospCode}}</span>
                </el-form-item>
                <el-form-item label="医院名称">
                    <span>{{childCharg.hospName}}</span>
                </el-form-item>
                <el-form-item label="医院等级">
                    <span>{{childCharg.hospRank}}</span>
                </el-form-item>
                <el-form-item label="标准价格">
                    <span>{{balanceMsg.standardPrice}}</span> 元 / 次
                </el-form-item>
                <el-form-item label="差价" prop="priceDif">
                    <el-input style="width:90%;margin-right:10px;" type="text" placeholder="请输入收费差价,例：100，-100" v-model="childCharg.priceDif"></el-input>元
                </el-form-item>
                <div style="display:flex;justify-content:flex-end;margin-top:40px;">
                    <el-button size='small' @click="cancel()">取消</el-button>
                    <el-button type="primary" size='small' @click="saveChildCharge()">保存</el-button>
                </div>
                <p style="margin-top:20px;margin-left:20px;">* 差价：即本医院对该下级医院的收费与标准价的差额，差额有负有正，正则加、负则减</p>
            </el-form>
        </el-dialog>
        <!-- 添加管理员弹窗 -->
        <el-dialog title="添加管理员" :visible.sync="addAdminDialog" :close-on-press-escape=false width="700px">
            <el-form :model="addAdminForm" :rules="addAdminFormRules" ref="addAdminForm" label-width="100px">
                <el-form-item label="管理员电话" prop='docPhone'>
                    <el-input v-model="addAdminForm.docPhone" @blur="getAdminInfoByTel" placeholder="管理员电话"></el-input>
                </el-form-item>
                <el-form-item label="管理员姓名" prop='docName'>
                    <el-input v-model="addAdminForm.docName" :disabled="disabled" placeholder="管理员姓名"></el-input>
                </el-form-item>
                <el-form-item label="管理员密码" prop='password'>
                    <el-input v-model="addAdminForm.password" :disabled="disabled" :type="type" placeholder="管理员密码"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop='passwordTwo'>
                    <el-input v-model="addAdminForm.passwordTwo" :disabled="disabled" :type="type" placeholder="再次输入密码"></el-input>
                </el-form-item>
                <div style="display:flex;justify-content:flex-end">
                    <el-button @click="cancel()">取 消</el-button>
                    <el-button type="primary" @click="saveAdmin('addAdminForm')">确定</el-button>
                </div>
            </el-form>
            
        </el-dialog>
        <!-- 添加关联医院弹窗 -->
        <el-dialog title="添加下级医院" :visible.sync="addDialog" width="700px">
            <el-row>
                <el-col align="center" :span="21">
                    <el-input v-model="addHosp.hospName"  @keyup.enter.native="getNonHospList()" placeholder="医院名称" clearable></el-input>
                </el-col>
                    <el-col align="center" :span="3">
                    <el-button circle icon="el-icon-search" @click="getNonHospList()"></el-button>
                </el-col>
            </el-row>
            <el-table :data="addHosp.body"  style="width: 100%">
                <el-table-column type="index" align="center" label="#" > </el-table-column>
                <el-table-column prop="hospName" align="center" label="医院名称" > </el-table-column>
                <el-table-column prop="hospAdminName" align="center" label="负责人" > </el-table-column>
                <el-table-column prop="hospAdminTel" align="center" label="电话"></el-table-column>
                <el-table-column align="center" label="操作" >
                    <template slot-scope="scope">
                        <el-button type="text" @click="addChildHosp(scope.row)">添 加</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination  :page-size="10" :page-count="5" layout="total, prev, pager, next" :total="addHosp.count" @current-change='changeAddPage' style="text-align:right"></el-pagination>
            </div>
            <el-button @click="cancel()">取 消</el-button>
        </el-dialog>
    </div>
</template>

<script>
import {isMoney,isSetMoney,isvalidCallAndPhone,isvalidPhone} from '@/service/common'
import { Loading } from 'element-ui';
//定义一个全局的变量，金额验证 
var validMoney=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入金额'))
    }else  if (!isMoney(value)){
        callback(new Error('金额格式错误或金额超额!'))
    }else {
        callback()
    }
}
var validSetMoney=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入金额'))
    }else  if (!isSetMoney(value)){
        callback(new Error('金额格式错误或金额超额!'))
    }else {
        callback()
    }
}
var validPhoneAcall=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入手机号码'))
    }else  if (!isvalidCallAndPhone(value)){
        callback(new Error('手机号码格式不对'))
    }else {
        callback()
    }
}
var validPhone=(rule, value,callback)=>{
    if (!value){
        callback(new Error('请输入手机号码'))
    }else  if (!isvalidPhone(value)){
        callback(new Error('手机号码格式不对'))
    }else {
        callback()
    }
}
export default {
    name:'hospDetail',
    data(){
        return{
            //医院信息
            hospMsg:{},
            hospRanks:[],//医院 级别
            //医院管理员信息
            adminMsg:{
                userName:'',
                userTel:''
            },
            //医院信息编辑
            editMsg:{
                hospId:'',
                hospCode:'',
                hospName:'',
                hospAddr:'',
                hospRank:'',
                hospDesc:'',
                hospAdminName:'',
                hospAdminTel:'',
            },
            //医院信息编辑规则
            editMsgRules:{
                hospAdminName:[{required: true, message: '请输入医院负责人姓名', trigger: 'blur'}],
                hospAdminTel:[{ required: true, trigger: 'blur', validator: validPhoneAcall }],
                hospAddr:[{required: true, message: '请输入医院详细地址', trigger: 'blur'}],
            },
            disabled:false,
            type:'password',
            editHosp:false,//医院信息编辑
            editChar:false,//收费设置修改
            flag:false,//是否有管理员
            addAdminDialog:false,//创建管理员
            chargeRule:false,//下级医院设置差价
            addDialog:false,//添加下级医院弹窗
            //创建医院 管理员
            addAdminForm:{
                docName:'',
                docPhone:'',
                password:'',
                passwordTwo:''
            },
            //创建管理员规则
            addAdminFormRules:{
                docName:[{required: true, message: '请输入医院管理员姓名', trigger: 'blur'}],
                docPhone:[{ required: true, trigger: 'blur', validator: validPhone }],
                password:[{required: true, message: '请输入密码', trigger: 'blur'},{min:6,message: '密码不得小于6位', trigger: 'blur'}],
                passwordTwo:[{required: true, message: '请再次输入密码', trigger: 'blur'},{min:6,message: '密码不得小于6位', trigger: 'blur'}],
            },
            //编辑账户信息
            editCharMsg:{
                hospId:'',
                chargeStatus:'02',
                standardPrice:0
            },
            //编辑账户规则
            editCharMsgRules:{
                chargeStatus:[],
                standardPrice:[{ required: true, trigger: 'blur', validator: validMoney }]
            },
            //账户信息
            balanceMsg:{
                standardPrice:300,
                chargeStatus:'01'
            },
            //下级医院列表
            hospList:{
                body:[],
                count:0,
                page:1
            },
            hospName:'',//名称查询下级医院
            //未添加的医院列表
            addHosp:{
                hospName:'',
                body:[],
                count:0
            },
            //下级医院收费设置
            childCharg:{
                hospId:'',
                hospCode:'',
                hospName:'',
                hospRank:'',
                priceDif:''
            },
            //下级医院收费设置规则
            childChargRules:{
                priceDif:[{ required: true, trigger: 'blur', validator: validSetMoney }]
            },
            loadingInstance:''
        }
    },
    mounted(){
        this.hospMsg=this.$common.getStorage('hospMsg');
        this.getHospDetail(this.hospMsg.hospId);
        this.getHospAccount(this.hospMsg.hospId);
        this.getHospList(1);
        this.listHospRank()
    },
    methods:{
        //查询医院详情
        getHospDetail(hospId){
            this.$ajax.post(this.$domain.getHospDetail,{
                hospId:hospId
            })
            .then(ret=>{
                console.log(ret.data)
                if(ret.data.code==10){
                    this.hospMsg=ret.data.data;
                    this.getAdminInfo(this.hospMsg);
                }
                else if(res.code=='401'){
                    this.$message.error('登录失败，请重新登录！');
                    this.$router.push({path:"/login"});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        //获得医院等级列表
        listHospRank(){
            this.$ajax.post(this.$domain.listHospRank)
            .then((ret)=>{
                var res=ret.data;
                if(res.code=="10"){
                    this.hospRanks=res.data
                }
                else if(res.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'})
                }
            })
        },
        //点击修改医院信息
        editHospMsg(){
            this.editHosp=true;
            this.editMsg={
                hospId:this.hospMsg.hospId,
                hospCode:this.hospMsg.hospCode,
                hospName:this.hospMsg.hospName,
                hospAddr:this.hospMsg.hospAddr,
                hospRank:this.hospMsg.hospRank,
                hospDesc:this.hospMsg.hospDesc,
                hospAdminName:this.hospMsg.hospAdminName,
                hospAdminTel:this.hospMsg.hospAdminTel,
            }
        },
        // 保存修改医院信息
        update(){
            this.$refs['editMsg'].validate((valid) => {
                if(valid){
                    this.loadingInstance=Loading.service({
                        text:'医院信息保存中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    this.$ajax.post(this.$domain.updateHosp,this.editMsg)
                    .then(ret=>{
                        this.loadingInstance.close();
                        var res=ret.data
                        if(res.code=="10"){
                            this.$message.success('修改成功！');
                            this.getHospDetail(this.hospMsg.hospId)
                            this.cancel();
                        }
                        else if(res.code=='401'){
                            this.$message.error('登录失败，请重新登录！');
                            this.$router.push({path:"/login"});
                        }
                        else{
                            this.$message.error('修改失败！');
                        }
                    })
                    .catch(err=>{
                        this.loadingInstance.close();
                    })
                }
                else{
                    // this.$message.error('表单有误！')
                }
            })
            
        },
        //查询医院管理员
        getAdminInfo(hosp){ 
            if(hosp.hospSaId==''){
                this.flag=false;
                return;
            }
            else{
                this.flag=true;
            }
            this.$ajax.post(this.$domain.getAdmin,{
                userId:hosp.hospSaId
            }).then((ret)=>{
                var res=ret.data;
                if(res.code=="10"){
                    this.adminMsg=res.data
                    this.adminDialog=true
                }
                else{
                    this.$message.error('获取管理员信息失败！');
                }
            })
        },
        //根据手机号查询用户信息
        getAdminInfoByTel(){
            if (!isvalidPhone(this.addAdminForm.docPhone)||!this.addAdminForm.docPhone){
                return;
            }
            this.loadingInstance=Loading.service({
                text:'手机号查询中，请稍后...',
                spinner:'el-icon-loading',
                background:'rgba(0, 0, 0, 0.8)'
            });
            this.$ajax.post(this.$domain.judgeDocIsExist,{
                phone:this.addAdminForm.docPhone
            })
            .then(ret=>{
                this.loadingInstance.close();
                if(ret.data.code==10){
                    this.disabled=true;
                    this.addAdminForm.docName=ret.data.data.docName
                    this.type="text";
                    this.addAdminForm.password='密码为第一所属医院登录密码'
                    this.addAdminForm.passwordTwo='密码为第一所属医院登录密码'
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录!')
                    this.$router.push({path:'/login'});
                }
                else{
                    this.disabled=false;
                    this.addAdminForm.password=''
                    this.addAdminForm.passwordTwo=''
                    this.type="password";
                    this.$message.success('该手机号第一次使用！')
                }
            })
            .catch(err=>{
                this.loadingInstance.close();
            })
        },
        // 添加管理员
        saveAdmin(){
            this.$refs['addAdminForm'].validate((valid) => {
                if (valid) {
                    if(this.addAdminForm.password!=this.addAdminForm.passwordTwo){
                        this.$message.error('两次密码输入不一致！');
                        return;
                    }
                    this.loadingInstance=Loading.service({
                        text:'医院管理员创建中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    var obj={
                        hospId:this.hospMsg.hospId,
                        hospName:this.hospMsg.hospName,
                        userName:this.addAdminForm.docName,
                        userTel:this.addAdminForm.docPhone,
                        password:this.$common.pwd99(this.addAdminForm.password),
                        passwordTwo:this.$common.pwd99(this.addAdminForm.passwordTwo)
                    }
                    this.$ajax.post(this.$domain.addHospAdmin,obj)
                    .then((ret)=>{
                        this.loadingInstance.close();
                        var res=ret.data
                        if(res.code=="10"){
                            this.$message.success('创建成功！');
                            this.cancel();
                            this.getHospDetail(this.hospMsg.hospId)
                        }
                        else if(res.code=='401'){
                            this.$message.error('登录失败，请重新登录！');
                            this.$router.push({path:"/login"});
                        }
                        else{
                            this.$message.error('创建失败！');
                        }
                    })
                }else {
                    return false;
                }
            })
        },
        // 重置管理员密码
        resetPassword(){
            this.$prompt('请输入密码', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern:/^[0-9A-Za-z]{6,}$/,
                inputErrorMessage:'密码由数字和字母组成，且不得小于6位',
                inputType:'password'
            }).then(({ value }) => {
                this.$ajax.post(this.$domain.resetAdminPwd,{
                    userId:this.hospMsg.hospSaId,
                    password:this.$common.pwd99(value)
                }).then((ret)=>{
                    console.log(ret.data)
                    var res=ret.data
                    if(res.code=="10"){
                        this.$message.success('重置成功！');
                    }
                    else{
                        this.$message.error('重置失败！');
                    }
                }).catch(()=>{
                    console.log("123")
                })

            }).catch((err)=>{
                console.log(err)
                console.log("中国加油！");
            })
        },
        //医生管理
        docManage(){
            this.$router.push({name:'docManage'})
        },
        //获取医院账户信息
        getHospAccount(hospId){
            this.$ajax.post(this.$domain.getCharge,{
                hospId:hospId
            })
            .then(ret=>{
                if(ret.data.code==10){
                    this.balanceMsg=ret.data.data;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        //点击修改账户信息
        editCharge(){
            this.editChar=true;
            this.editCharMsg={
                hospId:this.balanceMsg.hospId,
                chargeStatus:this.balanceMsg.chargeStatus,
                standardPrice:this.balanceMsg.standardPrice
            }
        },
        //保存修改账户信息
        saveHospAccount(){
            this.$refs['editMsg'].validate((valid) => {
                if (valid) {
                    this.loadingInstance=Loading.service({
                        text:'医院账户信息修改中...',
                        spinner:'el-icon-loading',
                        background:'rgba(0, 0, 0, 0.8)'
                    });
                    this.$ajax.post(this.$domain.saveCharge,this.editCharMsg)
                    .then(ret=>{
                        this.loadingInstance.close();
                        if(ret.data.code==10){
                            this.$message.success('账户信息修改成功！');
                            this.cancel();
                            this.getHospAccount(this.hospMsg.hospId)
                        }
                        else if(ret.data.code=='401'){
                            this.$message.error('登录失效，请重新登录！');
                            this.$router.push({path:'/login'});
                        }
                        else{
                            this.$message.error(ret.data.message);
                        }
                    })
                    .catch(err=>{
                        this.loadingInstance.close();
                    })
                }
            })
            
        },
        //获取下级医院列表
        getHospList(page){
            this.$ajax.post(this.$domain.listChildHosp,{
                hospId:this.hospMsg.hospId,
                hospName:this.hospName,
                page:page,
                rows:10
            })
            .then(ret=>{
                console.log(ret.data)
                if(ret.data.code==10){
                    this.hospList.body=ret.data.data.list;
                    this.hospList.count=ret.data.data.count;
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        //获取未添加的下级医院列表
        getNonHospList(page){
            if(!this.addHosp.hospName){
                this.$message.error('搜索医院名称不得为空！');
                return;
            }
            this.$ajax.post(this.$domain.notAssignedList,{
                hospId:this.hospMsg.hospId,
                hospName:this.addHosp.hospName,
                page:page,
                rows:10
            })
            .then(ret=>{
                console.log(ret.data)
                if(ret.data.code==10){
                    this.addHosp.body=ret.data.data.list;
                    this.addHosp.count=ret.data.data.count
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        //添加下级医院
        addChildHosp(row){
            this.loadingInstance=Loading.service({
                text:'下级医院添加中...',
                spinner:'el-icon-loading',
                background:'rgba(0, 0, 0, 0.8)'
            });
            this.$ajax.post(this.$domain.addChildHosp,{
                hospId:this.hospMsg.hospId,
                childHospId:row.hospId
            })
            .then(ret=>{
                this.loadingInstance.close();
                if(ret.data.code==10){
                    this.$message.success('添加成功!');
                    this.cancel();
                    this.getHospList(1);
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        //删除下级医院
        deleteHosp(row){
           this.$confirm('此操作将删除与该医院的关联, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loadingInstance=Loading.service({
                    text:'下级医院删除中...',
                    spinner:'el-icon-loading',
                    background:'rgba(0, 0, 0, 0.8)'
                });
                this.$ajax.post(this.$domain.delChild,{
                    hospId:this.hospMsg.hospId,
                    childHospId:row.hospId
                })
                .then(ret=>{
                    this.loadingInstance.close();
                    if(ret.data.code==10){
                        this.$message.success('下级医院删除成功！');
                        this.getHospList(1);
                    }
                    else if(ret.data.code=='401'){
                        this.$message.error('登录失效，请重新登录！');
                        this.$router.push({path:'/login'});
                    }
                    else{
                        this.$message.error(ret.data.message);
                    }
                })
            }) 
        },
        //点击设置下级医院的收费设置
        charge(row){
            this.chargeRule=true;
            this.childCharg={
                hospId:row.hospId,
                hospCode:row.hospCode,
                hospName:row.hospName,
                hospRank:row.hospRank,
                priceDif:row.priceDif
            }
        },
        //保存下级医院收费设置
        saveChildCharge(){
            this.loadingInstance=Loading.service({
                text:'下级医院收费设置修改中...',
                spinner:'el-icon-loading',
                background:'rgba(0, 0, 0, 0.8)'
            });
            this.$ajax.post(this.$domain.saveChildCharge,{
                hospId:this.hospMsg.hospId,
                childHospId:this.childCharg.hospId,
                priceDif:this.childCharg.priceDif
            })
            .then(ret=>{
                this.loadingInstance.close();
                console.log(ret.data)
                if(ret.data.code==10){
                    this.$message.success('收费设置成功！');
                    this.cancel();
                    this.getHospList(1);
                }
                else if(ret.data.code=='401'){
                    this.$message.error('登录失效，请重新登录！');
                    this.$router.push({path:'/login'});
                }
                else{
                    this.$message.error(ret.data.message);
                }
            })
        },
        //下级医院列表分页
        changePage(val){
            this.getHospList(val);
        },
        //未添加的医院列表分页
        changeAddPage(val){
            this.getNonHospList(val)
        },
        //是否收费转换
        transfCharge(val){
            switch(val){
                case '01':return '是';break;
                case '02':return '否';break;
            }
        },
        //取消
        cancel(){
            //医院编辑信息重置
            this.editHosp=false;
            this.editMsg={
                hospCode:'',
                hospName:'',
                hospAddr:'',
                hospRank:'',
                hospDesc:'',
                hospAdminName:'',
                hospAdminTel:'',
            }
            //医院账户修改
            this.editChar=false;
            this.editCharMsg={
                hospId:'',
                chargeStatus:'',
                standardPrice:''
            }
            //下级医院收费设置
            this.chargeRule=false;
            this.childCharg={
                hospId:'',
                hospCode:'',
                hospName:'',
                hospRank:'',
                priceDif:''
            }
            //下级医院添加
            this.addDialog=false,
            this.addHosp={
                hospName:'',
                body:[],
                count:0
            }
            //创建管理员
            this.addAdminDialog=false;
            this.addAdminForm={
                docName:'',
                docPhone:'',
                password:'',
                passwordTwo:''
            }
        }
    }
}
</script>

<style lang="scss" scoped>
#hospDetail{
    width:100%;
    min-width: 1200px;
    padding:0 10%;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    // padding: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    // box-sizing: border-box;
    .breadcrumb{
        width:100%;
        margin:10px auto;
        padding:20px 0;
        box-sizing: border-box;
    }
    .box-card{
        width:100%;
        margin:20px auto;
        padding:20px;
        max-width:1600px;
        .title{
            font-size: 18px;
            margin-top:10px;
            margin-bottom:30px;
            text-align: left;
            color:#5c6bc0;
            font-weight: bold;
            padding:10px 10px;
            border-bottom:1px solid #5c6bc0;
            position: relative;
            .editMsg{
                position: absolute;
                display: inline-block;
                top:12px;
                right:20px;
                width:20px;
                height:20px;
                cursor: pointer;
            }
        }
        .list{
            display: flex;
            justify-content: flex-start;
            padding:10px 20px;
            box-sizing: border-box;
            font-size: 16px;
            color:#333;
            line-height: 30px;
            .keyWord{
                margin-right:20px;
                width:90px;
                text-align: right;
            }
            .content{
                width:84%;
                text-align: left;
            }
            .el-radio-group{
                padding-top:10px;
                box-sizing: border-box;
            }
            .editPwd{
                color:#5c6bc0;
                margin-left:30px;
                cursor: pointer;
                font-size: 14px;
            }
        }
        .list-right{
            text-align:right;
            padding:10px;
            box-sizing: border-box;
        }
        .jiaoyi{
            margin-left:20px;
            color:#5c6bc0;
            cursor: pointer;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/hospDetail.vue